import React from 'react';

import { Box, Typography } from '@mui/material';

export const EmptyListRender: React.FunctionComponent = function () {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: '200px' }}
        >
            <Typography sx={{ opacity: '0.2' }}>(Aucun résultat)</Typography>
        </Box>
    );
};
